/**
 * Функция для правильного склонения слов в русском языке
 * @param {number} count - Число
 * @param {string} one - Форма для 1 (маршрут)
 * @param {string} few - Форма для 2-4 (маршрута)
 * @param {string} many - Форма для 5+ (маршрутов)
 * @returns {string} Правильная форма слова
 */
export const pluralize = (count, one, few, many) => {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return one;
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return few;
  }
  return many;
};

/**
 * Склонение по-чешски: 1 — одна форма, 2–4 — вторая, 0 и 5+ — третья.
 * В отличие от русского, 21, 22… склоняются как 5+ (21 dní, 22 dní)
 */
export const pluralizeCs = (count, one, few, many) => {
  if (count === 1) return one;
  if (count >= 2 && count <= 4) return few;
  return many;
};

/**
 * Функция для форматирования числа с правильным склонением
 * @param {number} count - Число
 * @param {string} one - Форма для 1 (маршрут)
 * @param {string} few - Форма для 2-4 (маршрута)
 * @param {string} many - Форма для 5+ (маршрутов)
 * @returns {string} Строка вида "5 маршрутов"
 */
export const pluralizeWithCount = (count, one, few, many) => {
  return `${count} ${pluralize(count, one, few, many)}`;
};